<template>
  <div>
    <div class="list-header">
      <b-row>
        <b-col md="6" class="box-date">
          <input v-model="list.name" readonly />
          <v-date-picker
            v-if="false"
            v-model="dateRange"
            :first-day-of-week="1"
            mode="range"
            :popover="{ placement: 'top', visibility: 'click' }"
            class="fill"
            :masks="{ input: 'YYYY/MM/DD' }"
          >
            <b-badge
              v-if="isOverdue"
              pill
              class="overdue cursor-pointer"
              variant="danger"
              >{{ formattedDate }}</b-badge
            >
            <b-badge
              v-else-if="dateRange.start || dateRange.end"
              pill
              class="cursor-pointer"
              variant="info"
            >
              {{ formattedDate }}
            </b-badge>
            <b-badge v-else pill class="cursor-pointer" variant="info">
              Due Date
            </b-badge>
          </v-date-picker>
        </b-col>
      </b-row>
      <b-row class="sort-row">
        <b-col md="10" class="sort-grid">
          <!-- <b-col md="1" class="align-center sort-trigger"> -->
          <i
            v-if="false"
            class="nav-icon i-Circular-Point sort-trigger numberSort"
            @click="sortTasks('number')"
          ></i>
          <!-- </b-col> -->
          <!-- <b-col md="3" class="align-center sort-trigger"> -->
          <i
            class="nav-icon i-Circular-Point hourSort sort-trigger"
            @click="sortTasks('hours')"
          ></i>
          <!-- </b-col> -->
          <!-- <b-col md="1" class="align-center sort-trigger"> -->
          <i
            class="nav-icon i-Circular-Point dateSort sort-trigger"
            @click="sortTasks('dueDate')"
          ></i>
          <!-- </b-col> -->
          <!-- <b-col md="2" class="align-center sort-trigger"> -->
          <i
            class="nav-icon i-Circular-Point statusSort sort-trigger"
            @click="sortTasks('status')"
          ></i>
          <!-- </b-col> -->
          <!-- <b-col md="2" class="align-center sort-trigger"> -->
          <i
            v-if="false"
            class="nav-icon i-Circular-Point prioritySort sort-trigger"
            @click="sortTasks('priority')"
          ></i>
          <!-- </b-col> -->
          <!-- <b-col md="3"> -->
          <!-- </b-col> -->
        </b-col>
        <b-col md="2">
          <ApolloMutation
            :mutation="require('@/graphql/Section/DeleteSection.gql')"
            :variables="{
              section: {
                id: list.id,
                clientId: list.clientId,
                name: list.name,
                end: list.end,
                start: list.start
              }
            }"
          >
            <template v-slot="{ mutate }">
              <i
                v-if="!fixed"
                v-b-popover.hover.topleft="'Archive'"
                class="nav-icon i-Remove f-r control"
                @click="archive(mutate)"
              ></i>
            </template>
          </ApolloMutation>
          <i
            v-if="list.tasks && list.tasks.length > 0"
            v-b-popover.hover.topleft="visible ? 'Collapse' : 'Reveal'"
            class="control"
            :class="`nav-icon i-Arrow-${visible ? 'Up' : 'Down'}-in-Circle f-r`"
            @click="changeListVisibility"
          ></i>
        </b-col>
      </b-row>
    </div>
    <b-collapse
      :id="`list-collapse_${list.id}`"
      :visible="visible"
      @hide="onCollapse(false)"
      @show="onCollapse(true)"
    >
      <div :id="list.id" class="list-group">
        <ListItem
          v-for="(task, index) in tasks"
          :key="task.id"
          v-model="tasks[index]"
          :client-id="list.clientId"
          :quote-id="list.quoteId"
          :is-ticket="true"
          @update-ticket="updateTicket"
        />
      </div>
    </b-collapse>
    <div class="list-group-item totals">
      <b-row>
        <b-col md="4">
          <b-progress
            v-if="!fixed"
            :max="list.tasks.length"
            height="10px"
            class="progress"
          >
            <!-- <b-progress-bar
              variant="success"
              class="progress-text"
              :value="completedTasks"
              :label="
                `${(
                  (completedTasks /
                    (list.tasks.length == 0 ? 1 : list.tasks.length)) *
                  100
                ).toFixed()}%`
              "
            ></b-progress-bar> -->
          </b-progress>
        </b-col>
        <b-col md="2">
          <b class="hours">{{ totalHours }}</b>
        </b-col>
        <b-col md="2"> </b-col>
        <b-col md="5">
          <b-badge v-if="!visible" pill variant="dark m-2 f-r total-pill"
            >Collapsed</b-badge
          >
        </b-col>
      </b-row>
    </div>
    <!-- <transition name="fade">
      <div
        v-show="trash.show"
        :id="`${list.id}-trash`"
        class="mb-20 trash-grid"
      >
        drop here to delete
      </div>
    </transition> -->
  </div>
</template>
<script>
import ListItem from "./listItem"
// import Sortable from "sortablejs"
import { mapGetters, mapState, mapMutations } from "vuex"
import debounce from "debounce"

export default {
  name: "TicketList",
  components: {
    ListItem
  },
  props: {
    value: {
      type: Object,
      default: null
    },
    fixed: {
      type: Boolean,
      deafult: false
    },
    reportType: {
      type: String,
      default: null
    },
    state: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      dateRange: { start: null, end: null },
      sortableRef: null,
      trashCanRef: null,
      hourSort: false,
      difficultySort: false,
      numberSort: false,
      tasksProxy: [],
      trash: {
        show: false,
        timeout: null
      },
      visible: true,
      collapsedPriorDrag: false,
      first: true,
      shortTerm: new Date(+new Date() + 12096e5)
    }
  },
  computed: {
    ...mapState({
      hideCompletedTasks: state => state.taskcontrol.hideCompletedTasks,
      hideHoldTasks: state => state.taskcontrol.hideHoldTasks,
      showShortTermTasks: state => state.taskcontrol.showShortTermTasks,
      showDueDates: state => state.taskcontrol.showDueDates,
      collapseAll: state => state.taskcontrol.collapseAll
    }),
    ...mapGetters({
      getCurrentUser: "getCurrentUser"
    }),
    list() {
      //Only want incomplete tickets
      return {
        ...this.value,
        tasks: this.value.tasks.filter(x => !x.completed)
      }
    },
    yesterday() {
      //TODO: change to moment
      return new Date(new Date().setDate(new Date().getDate() - 1))
    },
    tasks() {
      //Each of these account for the STATE (all/tasks/tickets/overdue...)
      //..As well as the show/hide completed/onhold
      switch (this.state) {
        case "Overdue":
          return this.list.tasks.filter(
            x =>
              (!this.hideCompletedTasks || !x.completed) &&
              (!this.hideHoldTasks || x.status != "On Hold") &&
              new Date(x.end) <= this.yesterday &&
              (!this.showShortTermTasks || new Date(x.start) <= this.shortTerm)
          )
        case "All":
        case "Tickets":
        default:
          return this.list.tasks.filter(
            x =>
              (!this.hideCompletedTasks || !x.completed) &&
              (!this.hideHoldTasks || x.status != "On Hold") &&
              (!this.showShortTermTasks || new Date(x.start) <= this.shortTerm)
          )
      }
    },
    totalHours() {
      var toReduce = this.tasks?.filter(x => x.hours)?.map(x => x.hours) ?? []
      if (!toReduce.length) return 0
      //Reduce new array of all task hours
      return (
        (toReduce.reduce(
          (accumulator, currentValue) =>
            parseFloat(accumulator) + parseFloat(currentValue)
        ) ??
          0) ||
        0
      )
    },
    completedTasks() {
      return this.value.tasks?.filter(task => {
        return task.completed
      }).length
    },
    isOverdue() {
      return this.dateRange.end && new Date(this.dateRange.end) <= new Date()
    },
    formattedDate() {
      if (!this.dateRange.start || !this.dateRange.end) return "Due Date"
      return `${this.$moment(this.dateRange.start).format(
        "DD MMM"
      )}-${this.$moment(this.dateRange.end).format("DD MMM")}`
    }
  },
  watch: {
    dateRange() {
      //When this changes make an event for this project's client
      // this.list.start = val.start
      // this.list.end = val.end
      //TODO change to loading
      if (!this.first) {
        this.updateList()
        //   this.$emit("update-list", this.list)
        //   let project = this.getProjectById(this.projectid)
        //   let client = this.getClientById(project.clientId)
        //   this.addOrUpdateEvent({
        //     list: this.list,
        //     projectId: project.id,
        //     client: client
        //   })
      }
      this.first = false
    }
  },
  async created() {
    this.list.tasks = this.list.tasks.sort((a, b) =>
      a.number > b.number ? 1 : -1
    )
    await this.setDateRange()
  },
  mounted() {
    // this.sortableRef = new Sortable(document.getElementById(this.list.id), {
    //   group: this.list.clientId,
    //   handle: ".task-number",
    //   forceFallback: true,
    //   animation: 150,
    //   onRemove: event => {
    //     //This is the event that gets triggered when a listItem gets removed from a list (deleted / change list)
    //     this.$emit("item-moved", {
    //       listFrom: event.from.id,
    //       listTo: event.to.id,
    //       taskId: event.item.id
    //     })
    //   },
    //   onSort: event => {
    //     if (event.from.id == event.to.id) {
    //       this.onTaskMove(event.oldIndex, event.newIndex)
    //     }
    //   },
    //   onStart: () => {
    //     this.$emit("dragging-started")
    //     document.body.style.cursor = "grabbing"
    //     this.trash.timeout = setTimeout(() => {
    //       this.trash.show = true
    //     }, 500)
    //   },
    //   onEnd: () => {
    //     this.$emit("dragging-stopped")
    //     document.body.style.cursor = "auto"
    //     clearTimeout(this.trash.timeout)
    //     this.trash.show = false
    //   }
    // })
    // setTimeout(() => {
    //   this.trashCanRef = new Sortable(
    //     document.getElementById(`${this.list.id}-trash`),
    //     {
    //       group: this.list.clientId,
    //       animation: 150
    //       // onEnd: () => {
    //       //   console.log("test")
    //       // }
    //     }
    //   )
    // }, 0)
    if (this.collapseAll) this.visible = false
    else {
      this.visible =
        this.list.tasks.find(task => {
          return !task.completed
        }) != null || !this.list.tasks?.length
    }
  },
  methods: {
    ...mapMutations({
      setcollapseAll: "setcollapseAll"
    }),
    changeListVisibility() {
      this.visible = !this.visible
    },
    async setDateRange() {
      this.dateRange = {
        start: this.list.start,
        end: this.list.end
      }
    },
    updateTicket(ticket) {
      this.$emit("update-ticket", ticket)
    },
    applicable(task) {
      if (this.userid) {
        if (task.users.includes(this.userid)) return true
        else return false
      }
      return true
    },
    updateList: debounce(function() {
      this.$emit("update-list", {
        id: this.list.id,
        clientId: this.list.clientId,
        name: this.list.name,
        end: this.$utils.getDate(this.dateRange.end),
        start: this.$utils.getDate(this.dateRange.start)
      })
    }, 500),
    //test
    onSeperateListDragging(isDragging) {
      if (isDragging) {
        if (!this.visible) this.collapsedPriorDrag = true
        this.visible = true
      } else {
        if (this.collapsedPriorDrag) this.visible = false
        this.collapsedPriorDrag = false
      }
    },
    async addTask() {
      const newTask = await this.$apollo.mutate({
        mutation: require("@/graphql/Task/AddTask.gql"),
        variables: {
          task: {
            sectionId: this.value.id
          }
        }
      })
      this.list.tasks.push(newTask.data.addTask)
    },
    displaySlackError(error) {
      this.$toasted.error(
        `There was an issue sending slack communications: ${error}`
      )
    },
    archive(mutate) {
      this.$dialog({
        title: `Delete: ${this.list?.name}`,
        content: "You're about to delete this list?",
        btns: [
          {
            label: "Go ahead",
            color: "#3f51b5",
            callback: () => {
              mutate()
            }
          },
          {
            label: "Cancel",
            color: "#444",
            ghost: true
          }
        ]
      })
    },
    onCollapse(value) {
      this.visible = value
      if (value) this.setcollapseAll(false)
    },
    sortTasks: function(sortProperty) {
      function compareNumber(asc) {
        return function(a, b) {
          if (a.number > b.number) return asc ? 1 : -1
          if (b.number > a.number) return asc ? -1 : 1
          return 0
        }
      }
      function compareHours(asc) {
        return function(a, b) {
          if (a.hours > b.hours) return asc ? 1 : -1
          if (b.hours > a.hours) return asc ? -1 : 1
          return 0
        }
      }
      function compareDueDates(asc) {
        return function(a, b) {
          if (a.end > b.end) return asc ? 1 : -1
          if (b.end > a.end) return asc ? -1 : 1
          return 0
        }
      }
      function comparePriority(asc) {
        return function(a, b) {
          if (
            (a.priority == "low" ? 1 : a.priority == "medium" ? 2 : 3) >
            (b.priority == "low" ? 1 : b.priority == "medium" ? 2 : 3)
          )
            return asc ? 1 : -1
          if (
            (b.priority == "low" ? 1 : b.priority == "medium" ? 2 : 3) >
            (a.priority == "low" ? 1 : a.priority == "medium" ? 2 : 3)
          )
            return asc ? -1 : 1
          return 0
        }
      }
      function compareStatus(asc) {
        return function(a, b) {
          if (a.status > b.status) return asc ? 1 : -1
          if (b.status > a.status) return asc ? -1 : 1
          return 0
        }
      }

      switch (sortProperty) {
        case "hours":
          this.hourSort = !this.hourSort
          this.list.tasks.sort(compareHours(this.hourSort))
          break
        case "status":
          this.statusSort = !this.statusSort
          return this.list.tasks.sort(compareStatus(this.statusSort))
        case "priority":
          this.prioritySort = !this.prioritySort
          return this.list.tasks.sort(comparePriority(this.prioritySort))
        case "dueDate":
          this.prioritySort = !this.prioritySort
          return this.list.tasks.sort(compareDueDates(this.prioritySort))
        case "number":
          this.numberSort = !this.numberSort
          return this.list.tasks.sort(compareNumber(this.numberSort))
      }
    },
    onTaskMove: function(oldIndex, newIndex) {
      while (oldIndex < 0) {
        oldIndex += this.list.tasks.length
      }
      while (newIndex < 0) {
        newIndex += this.list.tasks.length
      }
      this.list.tasks.splice(
        newIndex,
        0,
        this.list.tasks.splice(oldIndex, 1)[0]
      )
      return this.list.tasks
    }
    // getDate(pickerDate, valueDate) {
    //   if (pickerDate != valueDate)
    //     return new Date(pickerDate.setDate(pickerDate.getDate() + 1))
    //   else return pickerDate
    // }
  }
}
</script>
<style scoped>
.nav-icon {
  cursor: pointer;
}
input {
  border: none;
  width: 90%;
  background: transparent;
}
input:focus {
  outline: none;
}
.list-group {
  margin-bottom: -2px !important;
}
.totals {
  background-color: #dedede;
  border-color: #d2d2d2;
  margin-bottom: 20px !important;
  border-bottom-left-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.totals p {
  margin: 0;
}
.totals [class*="col-"] {
  text-align: center;
}
.totals .hours {
  float: right;
  margin-right: 15px;
}
.list-header {
  font-size: 1.01625rem;
  margin-bottom: 0.2rem;
}
.sort-grid {
  opacity: 0;
  transition: 0.3s;
}
.sort-grid:hover {
  opacity: 1;
}
.trash-grid {
  text-align: center;
  font-size: 14px;
  color: red;
  border: 1px solid;
  border-radius: 5px;
  background-color: #ffbdbd;
  padding: 7px;
}
.mb-20 {
  margin-bottom: 20px !important;
}

.highlight {
  background-color: #3f51b554;
  transition: background-color 1s linear;
}
.no-highlight {
  background-color: transparent;
}
.progress-text {
  font-size: 7px;
}
.progress {
  max-width: 200px;
  margin-top: 4px;
}
.total-pill {
  margin: 4px 0px 0px !important;
}
.box-date {
  margin-top: 0.5rem;
  margin-bottom: 0.7rem;
  display: flex;
  flex-direction: row;
  /* height: 1rem; */
}
.i-Add {
  margin-right: 0.3rem;
}
.fill {
  width: 6rem !important;
}

.sort-icons {
  display: flex;
  justify-content: space-between;
}
.sort-grid {
  display: grid;
  grid-template-areas: "numberSort hourSort dateSort statusSort prioritySort";
  grid-template-columns: 0.8fr 0.2fr 0.3fr 0.03fr 0.1fr;
}

.hourSort {
  grid-area: hourSort;
  /* margin-right: 1rem; */
}
.dateSort {
  grid-area: dateSort;
}
.statusSort {
  grid-area: statusSort;
}
.numberSort {
  margin-left: 0.8rem;
  grid-area: numberSort;
}
.prioritySort {
  grid-area: prioritySort;
}
</style>
